import React, { useRef } from 'react'

import { ContextMenuRef } from '@inno-ui/context-menu'
import {
  ONBOARDING_PINNED_APP_ID,
  ONBOARDING_PINNED_TOUR_ID
} from 'shared/hooks/useOnboarding'

import { AppButtonProps } from './AppButtonTypes'
import { AppButtonWrapper, LaunchPadButton, TopDockButton } from './components'

export const AppButton: React.FC<AppButtonProps> = ({
  buttonType,
  app,
  isLoading,
  ...props
}) => {
  const contextMenuRef = useRef<ContextMenuRef>(null)
  const dataTour =
    buttonType === 'launchpad' && app.id === ONBOARDING_PINNED_APP_ID
      ? ONBOARDING_PINNED_TOUR_ID
      : props.tourId

  return (
    <AppButtonWrapper
      app={app}
      buttonType={buttonType}
      handleOpenWindow={props.onClick}
      iconRefs={props.iconRefs}
      contextMenuRef={contextMenuRef}
      dataTour={dataTour}
      dataAppButtonWrapper={buttonType === 'topDock'}
      isLocked={props.isLocked}
    >
      {buttonType === 'launchpad' ? (
        <LaunchPadButton
          app={app}
          onClick={props.onClick}
          isLocked={props.isLocked}
          size={props.size}
          variant={props.variant}
          isLoading={isLoading}
        />
      ) : (
        <TopDockButton
          app={app}
          onClick={props.onClick}
          index={props.index}
          onLabelAnimationComplete={props.onLabelAnimationComplete}
          isLoading={isLoading}
          isLocked={props.isLocked}
          closeContextMenu={() => contextMenuRef.current?.close()}
        />
      )}
    </AppButtonWrapper>
  )
}
